import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';

import Box from '../../components/common/Box';
import EntitiesList from '../../components/pages/home/EntitiesList';
import TerritoryStats from '../../components/common/Stats/Territory';
import VendorsWidget from '../../components/pages/home/VendorsWidget';

const ComparisonDetails = React.memo(({ entity, sharedMode }) => {
	const { entity: entityType, id, title, dateStart, dateEnd } = entity;

	return <div className="comparison-container">
		<h2>{title} ({id}) released on {dateStart}</h2>
			<div>
				<EntitiesList trends={true} title="Top Products" entity="products" dateStart={dateStart} dateEnd={dateEnd} parentEntity={entityType} parentEntityIDs={id} addTotal={true} externalLinks={!sharedMode} />
				<EntitiesList trends={true} title="Top Artists" entity="artists" dateStart={dateStart} dateEnd={dateEnd} parentEntity={entityType} parentEntityIDs={id} addTotal={true} externalLinks={!sharedMode} />
				<EntitiesList trends={true} title="Top Tracks" entity="tracks" dateStart={dateStart} dateEnd={dateEnd} parentEntity={entityType} parentEntityIDs={id} externalLinks={!sharedMode} />
				<TerritoryStats dateStart={dateStart} dateEnd={dateEnd} entity={entityType} ids={id} />
				<VendorsWidget dateStart={dateStart} dateEnd={dateEnd} entity={entityType} id={id}/>
			</div>    
	</div>
});

export default ComparisonDetails
